import { useMicros } from './micro'
import { useShellStore } from '@/store'

export function useShellStart () {
  const shellStore = useShellStore()
  const micro = useMicros()

  function updateAuthData ({ micros, sidebar, tokens, user }) {
    // Update store
    shellStore.SET_SIDEBAR(sidebar)
    shellStore.SET_MICROS(micros)
    shellStore.SET_TOKENS(tokens)
    shellStore.SET_FARMACLOUD_MIGRATION_URL(user.farmacloudMigrationUrl)
    shellStore.SET_USER_INFO(user)
    // Update micros
    micro.setRoutes()
  }

  return { updateAuthData }
}
